import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components/macro';
import {NavBar, NavBarProps} from "../components";

// NOTE: This Component use Bulma Frameworks as base stylings.

export interface HeroProps {
  className?: string;
  children?: any;
  banner?:any;
  finished?: boolean;
}

const Root = styled.section`
  margin: 10px;
  .hero-cover {
    background-image: url('/images/background_mesh.png');
  }
  .hero-foot {
    z-index: 1;
  }      
`;

export function Hero(props: HeroProps & NavBarProps) {
  return (
    <Root className={classNames('hero is-fullheight is-dark has-background-image', props.className)}>
      <div className="hero-cover" />
      <div className="hero-head">
        <NavBar {...props} />
      </div>
      <div className="hero-body is-padding-top-0 is-padding-bottom-1">
        <div className="container">{props.children}</div>
      </div>
        {props.banner}
    </Root>
  );
}
